<template>
    <div id="MeasureAddDialog">
        <el-dialog title="测点信息" :visible.sync="dialogAdd.show" @close="closeDialog" width="660px" center
                   close-on-click-modal="false"
                   id="addCedianBox" :modal="false" :close-on-click-modal="false" @opened="setFormValue">
            <el-form ref="formData"
                     label-width="100px" :model="formData" :disabled="view">
                <div class="form-inline">
                    <el-form-item label="监测参数" class="form-group"
                                  :rules="{required: true,message:'请选择检测参数',trigger: 'change' }">
                        <el-cascader
                            :disabled="measureInfo!=null"
                            v-model="paramValue"
                            :options="paramOptions"
                            :props="{value:'code',label:'name',children:'childList',emitPath:false}"
                            :show-all-levels="false"
                            @change="paramChange"></el-cascader>
                    </el-form-item>
                    <el-form-item label="邮箱推送" class="form-group">
                        <el-switch
                            v-model="formData.noticeSwitch"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="开启"
                            inactive-text="关闭"
                        >
                        </el-switch>
                    </el-form-item>
                </div>
                
                <!-- 默认展示 -->
                <div class="form-inline">
                    <el-form-item label="测点编号" prop="measureNo" class="form-group"
                                  :rules="{required: true,message:'请填写测点编号',trigger: 'blur' }">
                        <el-input v-model="formData.measureNo" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="模块序列号" prop="deviceSn" class="form-group"
                                  :rules="{required: true,message:'请填写模块序列号',trigger: 'blur' }">
                        <el-input v-model="formData.deviceSn"></el-input>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="测点别名" prop="alias" class="form-group"
                                  :rules="{required: true,message:'请填写测点别名',trigger: 'blur' }">
                        <el-input v-model="formData.alias"></el-input>
                    </el-form-item>
                    <el-form-item label="构件选择" class="form-group">
                        <el-button @click="setObject">
                            <i class="iconfont icon-position"></i>
                        </el-button>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="预警阀值" prop="alarmDataJsonVo.earlyWarningValue" class="form-group"
                                  :rules="{required: true,message:'请填写预警阀值',trigger: 'blur' }">
                        <el-tag :key="tag" v-for="tag in dynamicTags1" :closable="!view" :disable-transitions="false"
                                @close="handleClose(tag,1)">
                            {{ tag }}
                        </el-tag>
                        <el-input class="input-new-tag" v-if="inputVisible1" v-model="inputValue1" ref="saveTagInput1"
                                  size="small"
                                  @keyup.enter.native="handleInputConfirm(1)"
                                  @blur="handleInputConfirm(1)"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput(1)">+</el-button>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="报警阀值" prop="alarmDataJsonVo.alarmValue" class="form-group"
                                  :rules="{required: true,message:'请填写报警阀值',trigger: 'blur' }">
                        <!--            <el-input v-model="formData.alarmDataJsonVo.alarmValue"></el-input>-->
                        <el-tag :key="tag" v-for="tag in dynamicTags2" :closable="!view" :disable-transitions="false"
                                @close="handleClose(tag,2)">
                            {{ tag }}
                        </el-tag>
                        <el-input class="input-new-tag" v-if="inputVisible2" v-model="inputValue2" ref="saveTagInput2"
                                  size="small"
                                  @keyup.enter.native="handleInputConfirm(2)"
                                  @blur="handleInputConfirm(2)"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput(2)">+</el-button>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="异变值" prop="alarmDataJsonVo.exceptionValue" class="form-group">
                        <!--            <el-input v-model="formData.alarmDataJsonVo.exceptionValue"></el-input>-->
                        <el-tag :key="tag" v-for="tag in dynamicTags3" :closable="!view" :disable-transitions="false"
                                @close="handleClose(tag,3)">
                            {{ tag }}
                        </el-tag>
                        <el-input class="input-new-tag" v-if="inputVisible3" v-model="inputValue3" ref="saveTagInput3"
                                  size="small"
                                  @keyup.enter.native="handleInputConfirm(3)"
                                  @blur="handleInputConfirm(3)"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput(3)">+</el-button>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="突变值" prop="alarmDataJsonVo.mutationValue" class="form-group">
                        <!--            <el-input v-model="formData.alarmDataJsonVo.mutationValue"></el-input>-->
                        <el-tag :key="tag" v-for="tag in dynamicTags4" :closable="!view" :disable-transitions="false"
                                @close="handleClose(tag,4)">
                            {{ tag }}
                        </el-tag>
                        <el-input class="input-new-tag" v-if="inputVisible4" v-model="inputValue4" ref="saveTagInput4"
                                  size="small"
                                  @keyup.enter.native="handleInputConfirm(4)"
                                  @blur="handleInputConfirm(4)"
                        >
                        </el-input>
                        <el-button v-else class="button-new-tag" size="small" @click="showInput(4)">+</el-button>
                    </el-form-item>
                </div>
                <div class="form-inline">
                    <el-form-item label="K值" prop="alarmDataJsonVo.kvalue" class="form-group">
                        <el-input v-model="formData.alarmDataJsonVo.kvalue"></el-input>
                    </el-form-item>
                    <el-form-item label="正常值范围" prop="normalValue2" class="form-group"
                                  :rules="{required: true,message:'请填写正常值范围',trigger: 'blur' }">
                        <el-input style="width: 60px" v-model="formData.normalValue1"></el-input>
                        <span>-</span>
                        <el-input style="width: 60px" v-model="formData.normalValue2"></el-input>
                    </el-form-item>
                </div>
                
                <el-collapse accordion>
                    <el-collapse-item title="更多设置">
                        <div class="form-inline">
                            <el-form-item label="设备类型" prop="alarmDataJsonVo.equipmentType" class="form-group">
                                <el-input v-model="formData.alarmDataJsonVo.equipmentType"></el-input>
                            </el-form-item>
                            <el-form-item label="设备编号" prop="alarmDataJsonVo.equipmentNo" class="form-group"
                            >
                                <el-input v-model="formData.alarmDataJsonVo.equipmentNo"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-inline">
                            <el-form-item label="设备电量" prop="alarmDataJsonVo.equipmentPower" class="form-group">
                                <el-input v-model="formData.alarmDataJsonVo.equipmentPower"></el-input>
                            </el-form-item>
                            <el-form-item label="设备经纬度" prop="alarmDataJsonVo.equipmentLongiAndLati"
                                          class="form-group">
                                <el-input v-model="formData.alarmDataJsonVo.equipmentLongiAndLati"></el-input>
                            </el-form-item>
                        </div>
                        <div class="form-inline">
                            <el-form-item label="通道编号" prop="alarmDataJsonVo.equipmentLongiAndLati"
                                          class="form-group">
                                <el-input v-model="formData.channel"></el-input>
                            </el-form-item>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            
            
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="close()">取 消</el-button>
                <el-button type="primary" @click="submitForm('formData')" v-show="!view">确 定</el-button>
                <el-button type="primary" @click="view=false" v-show="view">修 改</el-button>
            </div>
        </el-dialog>
        <el-dialog title="位置选择" :visible.sync="direct2D" :modal="false" width="1040px"
                   :close-on-click-modal="false">
            <div style="position: relative">
                <img :src="url+'/2021-06-23/2cb2bf0f-e037-46c7-8c43-b41c9ac7b14f/jikeng.png'"
                     id="childImg">
                <el-button type="danger" circle :style="{'position': 'absolute','top':yOffset+'px','left':xOffset+'px'}"
                           id="measureDirLogo" size="mini"
                           @mousedown.native="setDir($event)"><i class="el-icon-plus"/>
                </el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="direct2D=false">确 定</el-button>
            </div>
        
        </el-dialog>
        <el-dialog title="位置选择" :visible.sync="direct3D" :modal="false" width="1040px">
            <div style="width: 1000px;height: 300px;" id="bimfaceModel">
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="direct3D=false">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

export default {
    name: "measureAddDialog",
    props: {
        dialogAdd: Object,
        measureInfo: Object,
        paramOptions: {
            Type: Array,
            default: () => []
        }
    },
    data() {
        return {
            direct2D: false,
            direct3D: false,
            systemType: null,
            xOffset: 0,
            yOffset: 0,
            view: false,
            modelObjectId: null,
            rules: {
                deviceSn: [{ required: true, message: "请输入活动名称", trigger: "blur" },]
            },
            keyOptions: [
                {
                    value: "hight",
                    label: "高度"
                }, {
                    value: "width",
                    label: "宽度"
                }
            ],
            formData: {
                id: null,
                measureNo: null,
                alias: null,
                deviceSn: null,
                alarmDataJsonVo: {
                    earlyWarningValue: "",
                    alarmValue: "",
                    exceptionValue: "",
                    mutationValue: "",
                    kvalue: "",
                    normalValue: "",
                    frequencyValue: "1",
                    initValue: "0",
                    tvalue: "1",
                    equipmentType: "",//设备类型  陕西铁职院新增功能
                    equipmentNo: "",//编号  陕西铁职院新增功能
                    equipmentPower: "",//点量  陕西铁职院新增功能
                    equipmentLongiAndLati: "",//经纬度  陕西铁职院新增功能
                },
                noticeSwitch: false, //邮箱推送
                
                normalValue1: "",//正常值
                normalValue2: "",//正常值
                parameters: [{ name: "", keyValue: "", value: "" }],
                channel: ""
            },
            initForm: {//这个表单没用，用来存放初始值的，重置表单用
                id: null,
                measureNo: null,
                alias: null,
                deviceSn: null,
                alarmDataJsonVo: {
                    earlyWarningValue: "",
                    alarmValue: "",
                    exceptionValue: "",
                    mutationValue: "",
                    kvalue: "",
                    normalValue: "",
                    frequencyValue: "1",
                    initValue: "0",
                    tvalue: "1",
                    equipmentType: "",//设备类型  陕西铁职院新增功能
                    equipmentNo: "",//编号  陕西铁职院新增功能
                    equipmentPower: "",//点量  陕西铁职院新增功能
                    equipmentLongiAndLati: "",//经纬度  陕西铁职院新增功能
                },
                noticeSwitch: false, //邮箱推送
                normalValue1: "",
                normalValue2: "",
                parameters: [{ name: "", keyValue: "", value: "" }],
                channel: ""
            },
            paramValue: null,
            bimfaceOption: null,
            viewer3D: null,
            url: null,
            /*新增需求*/
            inputVisible1: false,
            inputValue1: "",
            dynamicTags1: [],
            inputVisible2: false,
            inputValue2: "",
            dynamicTags2: [],
            inputVisible3: false,
            inputValue3: "",
            dynamicTags3: [],
            inputVisible4: false,
            inputValue4: "",
            dynamicTags4: []
        }
    },
    mounted: function() {
        this.url = localStorage.getItem("url")
    },
    methods: {
        setFormValue() {
            let systemType = localStorage.getItem("systemType");
            this.systemType = systemType;
            if (this.measureInfo == null) {
                this.view = false;
                return;
            }
            this.view = true;
            this.formData.id = this.measureInfo.id;
            this.formData.alias = this.measureInfo.alias;
            this.formData.measureNo = this.measureInfo.measureNo
            this.formData.deviceSn = this.measureInfo.deviceSn;
            this.formData.channel = this.measureInfo.channel;
            this.formData.alarmDataJsonVo.earlyWarningValue = this.measureInfo.alarmDataJsonVo.earlyWarningValue;
            this.formData.alarmDataJsonVo.alarmValue = this.measureInfo.alarmDataJsonVo.alarmValue;
            this.formData.alarmDataJsonVo.exceptionValue = this.measureInfo.alarmDataJsonVo.exceptionValue;
            this.formData.alarmDataJsonVo.mutationValue = this.measureInfo.alarmDataJsonVo.mutationValue;
            
            this.formData.alarmDataJsonVo.equipmentType = this.measureInfo.alarmDataJsonVo.equipmentType;
            this.formData.alarmDataJsonVo.equipmentNo = this.measureInfo.alarmDataJsonVo.equipmentNo;
            this.formData.alarmDataJsonVo.equipmentPower = this.measureInfo.alarmDataJsonVo.equipmentPower;
            this.formData.alarmDataJsonVo.equipmentLongiAndLati = this.measureInfo.alarmDataJsonVo.equipmentLongiAndLati;
            this.formData.noticeSwitch = this.measureInfo.noticeSwitch;
            
            this.dynamicTags1 = this.measureInfo.alarmDataJsonVo.earlyWarningValue.split(",")
            this.dynamicTags2 = this.measureInfo.alarmDataJsonVo.alarmValue.split(",")
            this.dynamicTags3 = this.measureInfo.alarmDataJsonVo.exceptionValue.split(",")
            this.dynamicTags4 = this.measureInfo.alarmDataJsonVo.mutationValue.split(",")
            this.formData.alarmDataJsonVo.kvalue = this.measureInfo.alarmDataJsonVo.kvalue;
            if (systemType == "1") {
                if (this.measureInfo.measure3d) {
                    this.modelObjectId = this.measureInfo.measure3d.modelObjectId;
                }
            } else {
                this.xOffset = this.measureInfo.measure2d.measureX;
                this.yOffset = this.measureInfo.measure2d.measureY;
            }
            this.formData.measureX = this.xOffset;
            this.formData.measureY = this.yOffset;
            if (this.formData.id !== null) {
                this.formData.alarmDataJsonVo.normalValue = this.measureInfo.alarmDataJsonVo.normalValue
                this.formData.alarmDataJsonVo.frequencyValue = this.measureInfo.alarmDataJsonVo.frequencyValue,
                    this.formData.alarmDataJsonVo.initValue = this.measureInfo.alarmDataJsonVo.initValue,
                    this.formData.alarmDataJsonVo.tvalue = this.measureInfo.alarmDataJsonVo.tvalue
                this.formData.normalValue1 = this.measureInfo.alarmDataJsonVo.normalValue.split("~")[0]
                this.formData.normalValue2 = this.measureInfo.alarmDataJsonVo.normalValue.split("~")[1]
            }
            this.paramValue = this.formData.measureNo.substr(0, 6);
        },
        setDir(e) {
            let odiv = e.target;        //获取目标元素
            if (e.target.localName == "i") {
                odiv = e.target.offsetParent
            }
            
            //算出鼠标相对元素的位置
            let disX = e.clientX - odiv.offsetLeft;
            let disY = e.clientY - odiv.offsetTop;
            let maxY = document.getElementById("childImg").offsetHeight - 30;
            let maxX = document.getElementById("childImg").offsetWidth - 30;
            document.onmousemove = (e) => {       //鼠标按下并移动的事件
                //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
                let left = e.clientX - disX;
                let top = e.clientY - disY;
                
                this.positionX = top;
                this.positionY = left;
                if (top < 0) {
                    top = 0;
                }
                if (left < 0) {
                    left = 0
                }
                if (top > maxY) {
                    top = maxY;
                }
                if (left > maxX) {
                    left = maxX
                }
                odiv.style.left = left + "px";
                odiv.style.top = top + "px";
                this.yOffset = top;
                this.xOffset = left;
            };
            document.onmouseup = (e) => {
                document.onmousemove = null;
                document.onmouseup = null;
            };
        },
        setObject() {
            if (this.systemType == "1") {
                this.direct3D = true;
                //加载bimface
                if (this.viewer3D == null) {
                    let token = localStorage.getItem("path")
                    this.bimfaceOption = new BimfaceSDKLoaderConfig();
                    this.bimfaceOption.viewToken = token;
                    BimfaceSDKLoader.load(this.bimfaceOption, this.bimfaceSuccess, this.bimfaceFail);
                }
                
                
            } else {
                this.direct2D = true;
            }
        },
        bimfaceSuccess(viewMetaData) {
            let appConfig = new Glodon.Bimface.Application.WebApplication3DConfig();
            appConfig.domElement = document.getElementById("bimfaceModel");
            appConfig.Buttons = [];
            let app = new Glodon.Bimface.Application.WebApplication3D(appConfig);
            
            this.viewer3D = app.getViewer();
            this.viewer3D.hideViewHouse();
            this.viewer3D.addEventListener(Glodon.Bimface.Viewer.Viewer3DEvent.MouseDoubleClicked, this.objectClick);
            this.viewer3D.render();
            app.addView(viewMetaData.viewToken);
            
        },
        objectClick(data) {
            if (confirm("确认该构件为传感器位置？")) {
                this.modelObjectId = data.objectId;
            }
        },
        bimfaceFail(error) {
        },
        paramChange() {
            this.formData.measureNo = this.paramValue
        },
        submitForm(formName) {
            // debugger
            // if (this.systemType == "1" && this.modelObjectId != null) {
            //     this.formData.modelObjectId = this.modelObjectId;
            // }
            // else if (this.systemType == "2" && this.xOffset != null) {
            //     this.formData.measureX = this.xOffset;
            //     this.formData.measureY = this.yOffset;
            // } else {
            //     this.$message({
            //         type: "error",
            //         message: "未选择传感器位置",
            //         showClose: true
            //     });
            //     return;
            // }
            this.formData.modelObjectId = this.modelObjectId;
            if (Number(this.formData.normalValue2) < Number(this.formData.normalValue1)) {
                this.$message({
                    type: "error",
                    message: "正常值范围第一个值不能大于第二个",
                    showClose: true
                });
                return;
            } else {
                this.formData.alarmDataJsonVo.normalValue = this.formData.normalValue1 + "~" + this.formData.normalValue2
            }
            if (this.formData.alarmDataJsonVo.equipmentLongiAndLati) {
                if (this.formData.alarmDataJsonVo.equipmentLongiAndLati.indexOf("，")) {
                    this.formData.alarmDataJsonVo.equipmentLongiAndLati = this.formData.alarmDataJsonVo.equipmentLongiAndLati.replace("，", ",")
                }
            }
            
            
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.$axios.post("/api/monitor/project/measure/" +
                        (this.formData.id == null ? "createMeasure" : "updateMeasure"), this.formData).then(res => {
                        if (res.data.status == 200) {
                            this.$message({
                                type: "success",
                                message: "成功",
                                showClose: true
                            });
                            this.dialogAdd.show = false;
                            
                            this.$emit("update"); //子组件使用$emit触发父组件自定义事件
                        } else {
                            return false
                        }
                    });
                } else {
                    this.$message({ message: "有必填项未填写哦!请检查后提交" })
                }
            });
        },
        closeDialog() {
            // TODO: debugger与vue-devtools插件可以重点学习下（211207）
            // debugger
            this.formData = JSON.parse(JSON.stringify(this.initForm));
            this.dynamicTags1 = []
            this.dynamicTags2 = []
            this.dynamicTags3 = []
            this.dynamicTags4 = []
            this.paramValue = null;
            this.xOffset = 0;
            this.yOffset = 0;
        },
        compareValue() {
        
        },
        close() {
            this.dialogAdd.show = false;
        },
        /*新增需求*/
        handleClose(tag, num) {
            this["dynamicTags" + num].splice(this["dynamicTags" + num].indexOf(tag), 1);
            if (num === 1) {
                this.formData.alarmDataJsonVo.earlyWarningValue = this.dynamicTags1.toString()
            }
            if (num === 2) {
                this.formData.alarmDataJsonVo.alarmValue = this.dynamicTags2.toString()
            }
            if (num === 3) {
                this.formData.alarmDataJsonVo.exceptionValue = this.dynamicTags3.toString()
            }
            if (num === 4) {
                this.formData.alarmDataJsonVo.mutationValue = this.dynamicTags4.toString()
            }
        },
        showInput(num) {
            this["inputVisible" + num] = true;
            this.$nextTick(_ => {
                this.$refs["saveTagInput" + num].$refs.input.focus();
            });
        },
        handleInputConfirm(num) {
            let inputValue = this["inputValue" + num];
            if (inputValue) {
                if (this["dynamicTags" + num].indexOf(inputValue) !== -1) {
                    this.$message({ message: "相同值重复添加", type: "error" })
                } else {
                    this["dynamicTags" + num].push(inputValue);
                }
            }
            if (num === 1) {
                this.formData.alarmDataJsonVo.earlyWarningValue = this.dynamicTags1.toString()
            }
            if (num === 2) {
                this.formData.alarmDataJsonVo.alarmValue = this.dynamicTags2.toString()
            }
            if (num === 3) {
                this.formData.alarmDataJsonVo.exceptionValue = this.dynamicTags3.toString()
            }
            if (num === 4) {
                this.formData.alarmDataJsonVo.mutationValue = this.dynamicTags4.toString()
            }
            this["inputVisible" + num] = false;
            this["inputValue" + num] = "";
        },
        /*增加参数*/
        addInfo() {
            this.formData.parameters.push({
                name: "",
                keyValue: "",
                value: "",
                key: Date.now()
            });
        },
        removeParameters(item) {
            var index = this.formData.parameters.indexOf(item)
            if (index !== -1) {
                this.formData.parameters.splice(index, 1)
            }
        },
    }
}
</script>

<style>
.el-dialog__header {
    text-align: center;
    padding: 20px 30px 10px;
    /*background-image: url('../../assets/img/modal_bg.png')*/
    background: linear-gradient(
        -90deg, rgb(60, 32, 242) 0%, rgb(52, 87, 222) 100%);
    border-radius: 2.5px 2.5px 0px 0px;
    transition: unset;
}

.el-dialog__body {
    padding: 10px 20px;
}

.el-dialog__title {
    font-size: 18px;
    color: #fff;
}


#MeasureAddDialog .el-form-item {
    margin-bottom: 8px;
}

#MeasureAddDialog .el-cascader .el-input .el-input__inner {
    background-color: unset;
    color: #000;
}

.el-input--suffix .el-input__inner {
    padding-right: 15px;
}
</style>

<style scoped>
.form-group {
    display: inline-block
}

.form-inline {
    margin-bottom: 10px;
}

.el-tag {
    background-color: #ffffff;
    color: #333333;
}

.el-tag + .el-tag {
    margin-left: 10px;
}

.button-new-tag {
    /*margin-left: 10px;*/
    width: 90px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}

.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/project/measure-add-dialog.vue